import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AttachmentModel }    from './typings/attachment';
import { AttachmentsService } from './attachments.service';

@Component({
  selector   : 'wor-attachments-select',
  template: require('./attachments.select.component.html')
})
export class AttachmentsSelectComponent {
  @Input() attachments: Array<AttachmentModel> = [];
  @Input() hasCancel                           = true;
  @Input() isVerifying                         = false;

  @Output() onCancel = new EventEmitter<void>();
  @Output() onSelect = new EventEmitter<Array<string>>();

  constructor (
    public attachmentsService: AttachmentsService
  ) {}

  get selected () : Array<string> {
    return this.attachments.filter(attachment => attachment.selected)
      .map(attachment => attachment.id);
  }

  select ( attachment : AttachmentModel ) : void {
    attachment.selected = !attachment.selected;
  }

  selectAll () : void {
    const selected = this.selected.length !== this.attachments.length;

    this.attachments.forEach(attachment => attachment.selected = selected);
  }

  trackByAttachmentId ( _index : number, attachment : AttachmentModel ) : string {
    return attachment.id;
  }
}
